import type { Folga } from '../three/viewerCore.js';

/**
 * Lista das folgas (distâncias até a peça vizinha) no painel da peça.
 *
 * Por que existe: no 3D a cota tem o número, mas não diz ATÉ QUAL PEÇA é — e o
 * rótulo ainda pode cair fora da tela. O marceneiro reclamava de "caçar" a
 * medida girando o móvel. Aqui ele lê "3 mm até Divisória_2" em texto, e cada
 * linha leva para a vizinha com um toque.
 *
 * A cor do quadradinho é a MESMA da cota desenhada no 3D (GAP_COLORS do
 * viewerCore): é o que amarra a linha de texto ao desenho na tela.
 */

const ROTULOS: Record<Folga['direcao'], { seta: string; texto: string; cor: string }> = {
  esquerda: { seta: '←', texto: 'Esquerda', cor: '#ff9800' },
  direita: { seta: '→', texto: 'Direita', cor: '#ff5252' },
  cima: { seta: '↑', texto: 'Cima', cor: '#ffd166' },
  baixo: { seta: '↓', texto: 'Baixo', cor: '#8be34a' },
  frente: { seta: '↗', texto: 'Frente', cor: '#42c5f5' },
  fundo: { seta: '↙', texto: 'Fundo', cor: '#e060f0' },
};

export function ListaFolgas({
  folgas, nomeDe, onEscolher,
}: {
  folgas: Folga[];
  /** Nome da peça no banco (vazio quando o móvel não tem nome para ela). */
  nomeDe: (id: string) => string;
  onEscolher: (id: string) => void;
}) {
  if (!folgas.length) return null;
  return (
    <div className="vw-folgas">
      <div className="vw-folgas-tit">Folgas</div>
      {folgas.map((f) => {
        const r = ROTULOS[f.direcao];
        const nome = f.vizinho ? nomeDe(f.vizinho) || f.vizinho : '';
        // Sem jargão: "encostada" quando toca, "até" quando há vão.
        const detalhe = !f.vizinho
          ? 'nada deste lado'
          : f.encostada ? `encostada em ${nome}` : `até ${nome}`;
        return (
          <button
            key={f.direcao}
            type="button"
            className="vw-folga"
            data-direcao={f.direcao}
            data-vizinho={f.vizinho ?? ''}
            disabled={!f.vizinho}
            title={f.vizinho ? `Ver ${nome}` : 'Nada nessa direção'}
            onClick={() => { if (f.vizinho) onEscolher(f.vizinho); }}
          >
            <span className="vw-folga-cor" style={{ background: r.cor }} aria-hidden="true" />
            <span className="vw-folga-dir" style={{ color: r.cor }}>{r.seta} {r.texto}</span>
            <span className="vw-folga-mm">{f.folga_mm == null ? '—' : `${f.folga_mm} mm`}</span>
            <span className="vw-folga-viz">{detalhe}</span>
          </button>
        );
      })}
    </div>
  );
}
